const nsp = "credentials/";

const CREDENTIAL_ACTION_TYPES = {
  SET_CREDENTIAL: `${nsp}SET_CREDENTIAL`,
};

export default CREDENTIAL_ACTION_TYPES;
